import { render } from "./TeamRosterSunB.vue?vue&type=template&id=02426f46&scoped=true"
import script from "./TeamRosterSunB.vue?vue&type=script&scoped=true&lang=js"
export * from "./TeamRosterSunB.vue?vue&type=script&scoped=true&lang=js"

import "./TeamRosterSunB.vue?vue&type=style&index=0&id=02426f46&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02426f46"]])

export default __exports__